import { useRouter } from "@tanstack/react-router";
import styles from "./ServiceCatalog.module.scss";
import autojam from "./assets/autojam.webp";
import autotable from "./assets/autotable.webp";
import { AutoJamIcon } from "./assets/AutoJamIcon";
import { AutoTableIcon } from "./assets/AutoTableIcon";
import { availableServices } from "./config/services";
import { type Person } from "@/shared/hooks/usePeople";
import { Card } from "@/shared/ui";
import { Container } from "@/shared/ui";

export interface ServiceCard {
  id: string;
  type: "auto_table" | "auto_jam";
}

interface Props {
  personId: string;
  supplier?: Person;
}

export function ServiceCatalog({ personId, supplier }: Props) {
  const serviceCards = availableServices;

  const router = useRouter();

  const handleClick = (id: string, pId: string) => {
    router.navigate({
      to: "/service/$id",
      params: { id },
      search: { pId },
    });
  };

  if (!personId || serviceCards.length === 0) {
    return (
      <Card>
        <Container>
          <div className={styles.servicesBlock}>
            <div className={styles.header}>
              <h2 className={styles.title}>Сервисы</h2>
            </div>
            <div className={styles.emptyState}>
              <h2 className={styles.emptyTitle}>Нет доступных сервисов</h2>
              <p className={styles.emptyDescription}>
                Добавьте компанию через токен доступа
              </p>
            </div>
          </div>
        </Container>
      </Card>
    );
  }

  return (
    <Card>
      <Container>
        <div className={styles.header}>
          <h2 className={styles.title}>Сервисы</h2>
        </div>

        <div className={styles.servicesContainer}>
          {serviceCards.map((card: ServiceCard) => {
            const tableType = card.type === "auto_table" ? "auto" : "jam";
            const isConnected = supplier?.tables?.some(
              (t) => t.table_type === tableType,
            );

            return (
              <div
                key={card.id}
                className={`${styles.serviceCardWrapper} ${isConnected ? styles.serviceCardSelected : ""}`}
                onClick={() => handleClick(card.id, personId)}
              >
                <div className={styles.serviceCard}>
                  <div className={styles.cardContent}>
                    <h3 className={styles.cardTitle}>
                      {card.type === "auto_jam" && (
                        <AutoJamIcon className={styles.autoJamIcon} />
                      )}
                      {card.type === "auto_table" && (
                        <AutoTableIcon className={styles.autoTablesIcon} />
                      )}
                    </h3>
                    <div className={styles.imagePlaceholder}>
                      <div className={styles.placeholderIcon}>
                        {card.type === "auto_jam" && <img src={autojam} />}
                        {card.type === "auto_table" && <img src={autotable} />}
                      </div>
                    </div>
                  </div>
                  <button className={styles.tableButton}>
                    {isConnected ? "Моя таблица" : "Подключить"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </Card>
  );
}
